import _slicedToArray from "/Users/andrewgallagher/Documents/eth/highrises/static-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useReducer } from 'react';
import { BlockNumberContext } from './context';
import { blockNumberReducer } from '../common/reducer';
import { useDebounce, useEthers } from '../../../hooks';
import { subscribeToNewBlock } from '../common/subscribeToNewBlock';
/**
 * @internal Intended for internal use - use it on your own risk
 */

export function BlockNumberProvider(_ref) {
  var children = _ref.children;

  var _useEthers = useEthers(),
      library = _useEthers.library,
      chainId = _useEthers.chainId;

  var _useReducer = useReducer(blockNumberReducer, {}),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  useEffect(function () {
    return subscribeToNewBlock(library, chainId, dispatch);
  }, [library, chainId]);
  var debouncedState = useDebounce(state, 100);
  var blockNumber = chainId !== undefined ? debouncedState[chainId] : undefined;
  return _jsx(BlockNumberContext.Provider, {
    value: blockNumber,
    children: children
  });
}